<template>
    <div>
        <UserLogin></UserLogin>
    </div>
</template>

<script>
import UserLogin from "@/components/user/UserLogin.vue";

export default {
    name: "UserLoginView",
    components: {
        UserLogin,
        
    }
}
</script>

<style lang="scss" scoped></style>